
<script>

   import {
      mapGetters,
      mapActions
   } from "vuex";
  
   import _ from "lodash";
   import _system from '../../libs/system';

   import config from '../../libs/config.json';
   import axios from 'axios';

   import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';
   import system from '../../libs/system';
import router from "../../router";

   window.plans = [];

   export default {
   name: "UpgradeShopify",
   data() {
      return {
         config,
         subscribed: false,
         currentShopifyPage: '',
         activeDiscountRender: '',
         loading: false,
         plans: [{
            name: 'Essentials',
            price: 99,
            actualPrice: 99,
            period: 'month',
            visitors: 10000,
            products: 500
         },{
            name: 'Scale',
            price: 199,
            actualPrice: 199,
            period: 'month',
            visitors: 50000,
            products: 2000,
            features: [
               'AI Shopping Assistant for Instagram',
               'Team Collaboration'
            ]
         },{
            name: 'Pro',
            price: 299,
            actualPrice: 299,
            period: 'month',
            visitors: 125000,
            products: 5000,
            features: [
               'Browsing History',
               'Remove Branding',
            ]
         }, {
            name: 'Essentials',
            price: 948,
            actualPrice: 1188,
            period: 'year',
            visitors: 10000,
            products: 500
         },{
            name: 'Scale',
            price: 1910,
            actualPrice: 2388,
            period: 'year',
            visitors: 50000,
            products: 2000,
            features: [
               'AI Shopping Assistant for Instagram',
               'Team Collaboration'
            ]
         },{
            name: 'Pro',
            price: 2870,
            actualPrice: 3588,
            period: 'year',
            visitors: 125000,
            products: 5000,
            features: [
               'Browsing History',
               'Remove Branding',
            ]
         }]
      }
   },
   computed: {
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('networks', ['networksByName']),
   ...mapGetters('accounts', ['accounts']),
      getAnnualPlans(){
         return _.filter(this.plans, {period: 'year'});
      },
      getMonthlyPlans(){
         return _.filter(this.plans, {period: 'month'});
      }
   },
   methods: {
   ...mapActions("session", ["setUser"]),
      upgrade(plan){
         this.loading = true;
         var requestBody = {
         shopClientData: this.currentShopifyPage,
         subscriptionVariables: {
            name: plan.name,
            returnUrl: config.url + '/shopify/upgrade/redirect',
            lineItems: [
               {
                  plan: {
                  appRecurringPricingDetails: {
                     price: {
                        amount: plan.actualPrice.toFixed(2),
                        currencyCode: "USD"
                     },
                     interval: plan.period === 'month' ? 'EVERY_30_DAYS' : 'ANNUAL'
                  }
                  }
               }
            ]
            }
      };

      if(this.getUser.email.includes('burcu') || this.getUser.email.includes('hofsilk') ){
         requestBody.subscriptionVariables.lineItems[0].plan.appRecurringPricingDetails.discount = { "value": {
                "percentage": 0.30
              }
            }
      }else{
         requestBody.subscriptionVariables.lineItems[0].plan.appRecurringPricingDetails.discount = { "value": {
                "percentage": 0.20
              }
            }
      }

      axios.post( config.url + '/shopify/upgrade', requestBody)
        .then(response => {
          console.log('Upgrade response:', response.data);

          let confirmationLink = _.get(response.data, 'data.appSubscriptionCreate.confirmationUrl', '');
          console.log(confirmationLink)
            this.loading = false;
            if(confirmationLink.length) window.location.href = confirmationLink;

        })
        .catch(error => {
          console.error('Error upgrading subscription:', error);
          // Handle error
        });
      }
   },
   mounted(){

      //check for suceed query at page load
      if(this.$route.query.succeed && this.$route.query.succeed !== 'none'){
         this.subscribed = true;
         iziToast.success({
            title: 'Success',
            message: 'Your subscription has been successfully upgraded!',
            position: 'topRight'
         });
      }

   },
   created(){
      this.currentShopifyPage = _.find(this.accounts, { platform: this.networksByName['Shopify']._id });

      if(this.getUser.email.includes('burcu') || this.getUser.email.includes('hofsilk') ){
        this.activeDiscountRender = "+ 10%"
      }
   }
}

</script>

<template>

<div class="ui container">


   <div v-if="subscribed" class="ui positive message">
  <i class="close icon"></i>
  <div class="header">
    Your Subscription is Successful
  </div>
  <p>Thank you for subscribing!</p>
</div>

   <div class="ui header">Monthly Plans</div>
<div class="ui stackable three column grid">

   <div class="column" v-for="plan in getMonthlyPlans" :key="plan.name" >
   <div class="ui cards">
      <div class="card">
         <div class="content">
            <div class="header">
            {{plan.name}}
            </div>
            <div style="margin:0;" class="ui small header">
               ${{plan.price}}
            </div>
            <div class="meta">
            per {{plan.period}}
            </div>
            <div class="description">
            <ul>
               <li>Up to {{plan.visitors}} Visitors</li>
               <li>Up to {{plan.products}} Products</li>
            </ul>
            <ul v-if="plan.features">
               <li v-for="feature in plan.features" :key="feature"> {{ feature }} </li>
            </ul>
            </div>
         </div>
         <div class="extra content">
            <div class="ui two buttons">
               <div @click="upgrade(plan)" class="ui teal button">Upgrade on Shopify</div>
            </div>
         </div>
      </div>
      </div>
   </div>

</div>
<div class="ui divider"></div>
<div class="ui header">Yearly Plans <span class="ui black label">20% Discounted</span><span class="ui green label" v-if="activeDiscountRender && activeDiscountRender.length">{{ activeDiscountRender }} Extra Discount Applied</span> </div>
<div class="ui stackable three column grid">
   <div class="column" v-for="plan in getAnnualPlans" :key="plan.name" >
   <div class="ui cards">
      <div class="card">
         <div class="content">
            <div class="header">
            {{plan.name}}
            </div>
            <div style="margin:0;" class="ui small header">
             ${{ (plan.actualPrice/12) }} x 12 =  ${{ (activeDiscountRender.length) ? plan.actualPrice + ' => $' + (plan.actualPrice - (plan.actualPrice * 0.3)).toFixed(2) : plan.price}}
            </div>
            <div class="meta">
            per {{plan.period}}
            </div>
            <div class="description">
            <ul>
               <li>Up to {{plan.visitors}} Visitors</li>
               <li>Up to {{plan.products}} Products</li>
            </ul>
            <ul v-if="plan.features">
               <li v-for="feature in plan.features" :key="feature"> {{ feature }} </li>
            </ul>
            </div>
         </div>
         <div class="extra content">
            <div class="ui two buttons">
               <div @click="upgrade(plan)" :class="{ 'loading': loading }" class="ui teal button" >Upgrade on Shopify</div>
            </div>
         </div>
      </div>
      </div>
   </div>
</div>

</div>

</template>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/UpgradeShopify.vue